import React from 'react';
export function OtherTiers() {
  return <section className="py-24 px-6 md:px-12 lg:px-24 max-w-7xl mx-auto" data-id="element-39" data-mp="3kqv8qsyhiar3">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-16 md:gap-24 max-w-4xl" data-id="element-40" data-mp="18llxui7dfstk">
        <div data-id="element-41" data-mp="twfs0be134cp">
          <h3 className="font-serif text-3xl mb-3" data-id="element-42" data-mp="twplwa271vno">Vera Method</h3>
          <div className="font-mono text-xs uppercase tracking-widest text-brass mb-6" data-id="element-43" data-mp="yuhjnkpisbzs">
            By Waitlist
          </div>
          <p className="font-sans text-base font-light text-ink/70 leading-relaxed" data-id="element-44" data-mp="1mldbghtz7771">
            One-on-one with Ashley. Two private calls a month, your complete
            system in the Vera app, and support between calls answered by
            Ashley.
          </p>
        </div>

        <div data-id="element-45" data-mp="1hkfsw4520b50">
          <h3 className="font-serif text-3xl mb-3" data-id="element-46" data-mp="1hk7hkgokxdvx">Vera Standard</h3>
          <div className="font-mono text-xs uppercase tracking-widest text-brass mb-6" data-id="element-47" data-mp="178t3banwcqx">
            By Waitlist
          </div>
          <p className="font-sans text-base font-light text-ink/70 leading-relaxed" data-id="element-48" data-mp="674wp9fg625y">
            Your program, delivered. Training and nutrition built for you,
            reviewed every two weeks with clear direction on what to do next.
          </p>
        </div>
      </div>
    </section>;
}